import { useParams } from "react-router-dom";
import "./PatientDetails.scss";
import { useEffect, useRef, useState } from "react";
import useStore from "../store/store";
import annotationPlugin from "chartjs-plugin-annotation";
import NoPainImage from "../assets/images/NoPainImage.svg";
import MildPainImage from "../assets/images/MildPainImage.svg";
import ModeratePainImage from "../assets/images/ModeratePainImage.svg";
import SeverePainImage from "../assets/images/SeverePainImage.svg";
import NAImage from "../assets/images/NotApplicable.svg";
import BarChart from "../components/BarChart";
import PatientProfile from "../components/PatientProfile";
import PatientHistory from "../components/PatientHistory";
import SessionResult from "../components/SessionResult";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import PainAssessment from "../components/PainAssessment";
import { getSessionControlState } from "../utility/sessionControlState";

ChartJS.register(
  BarElement,
  LineElement,
  CategoryScale,
  PointElement,
  LinearScale,
  Tooltip,
  Legend,
  annotationPlugin
);
const PatientDetails = () => {
  const { patientID } = useParams();
  const [selectedTab, setSelectedTab] = useState("Profile");
  const [sessionType, setSessionType] = useState("Detect");
  const [sessionStarted, setSessionStarted] = useState(false);
  const [openSession, setOpenSession] = useState(false);
  const [preSession, setPreSession] = useState(true);
  const [selectedDuration, setSelectedDuration] = useState(1);
  const [selectedTarget, setSelectedTarget] = useState(null);
  const [currentMinutes, setCurrentMinutes] = useState(selectedDuration - 1);
  const [leftForce, setLeftForce] = useState(0);
  const [rightForce, setRightForce] = useState(0);
  const [leftForceArray, setLeftForceArray] = useState([]);
  const [rightForceArray, setRightForceArray] = useState([]);
  const [leftWaveform, setLeftWaveform] = useState([]);
  const [rightWaveform, setRightWaveform] = useState([]);
  const [avgLeftForce, setAvgLeftForce] = useState(0);
  const [avgRightForce, setAvgRightForce] = useState(0);
  const [currentSeconds, setCurrentSeconds] = useState(59);
  const [endSession, setEndSession] = useState(false);
  const [loadedImages, setLoadedImages] = useState({});
  const intervalRef = useRef(null);
  const feedbackHandlerRef = useRef(null);
  const feedbackListenerRef = useRef(null);
  const [ledCharacteristic, setLedCharacteristic] = useState(null);
  const [clinicianNotes, setClinicianNotes] = useState({});
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const [saveChanges, setSaveChanges] = useState(false);
  const [device, setDevice] = useState(null);
  const [isHubConnected, setIsHubConnected] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);
  const [deviceName, setDeviceName] = useState("");
  const [sessionResult, setSessionResult] = useState({});
  const [feedbackCharacteristic, setFeedbackCharacteristic] = useState(null);
  const [dataLog, setDataLog] = useState([]);
  let sessionCount = 1;
  const [goNext, setGoNext] = useState(false);
  const [esp32Data, setEsp32Data] = useState("");
  const [selectedTreatmentStatus, setSelectedTreatmentStatus] = useState(null);
  const [stepCount, setStepCount] = useState(0);
  const [stepTime, setStepTime] = useState([0]);
  const [painCharts, setPainCharts] = useState({
    leftHip: true,
    leftKnee: true,
    leftAnkle: true,
  });
  const [formData, setFormData] = useState({
    leftHip: "",
    rightHip: "",
    leftKnee: "",
    rightKnee: "",
    leftAnkle: "",
    rightAnkle: "",
  });
  const imageMap = {
    "Not Applicable": NAImage,
    "No Pain": NoPainImage,
    Mild: MildPainImage,
    Moderate: ModeratePainImage,
    Severe: SeverePainImage,
  };

  const [parsedData, setParsedData] = useState("");
  const [patientImage, setPatientImage] = useState(null);
  const role = localStorage.getItem("role");

  const { patient, fetchPatientByUID, fetchPatientHistory, patientHistory } =
    useStore();
  useEffect(() => {
    fetchPatientByUID(patientID);
  }, [patientID, fetchPatientByUID]);

  useEffect(() => {
    if (patient) {
      console.log("Is it loading ? ", patient);
      setPatientImage(patient.patientImage || null);
      setClinicianNotes(patient.clinicianNotes || {});
      setSelectedTreatmentStatus(patient.treatmentStatus || "On treatment");
      fetchPatientHistory(patient._id);
    }
  }, [patient, fetchPatientHistory, patientID]);

  useEffect(() => {
    if (sessionType === "Treat") {
      setSelectedTarget(112);
    } else {
      setSelectedTarget(null);
    }
  }, [sessionType]);

  useEffect(() => {
    // Preload images with promises
    console.log("Patient deets ", patient);
    const images = {};
    const loadImage = (name, src) => {
      return new Promise((resolve) => {
        const img = new Image(30, 30);
        img.src = src;
        img.onload = () => {
          images[name] = img;
          resolve();
        };
      });
    };

    Promise.all([
      loadImage("4", NAImage),
      loadImage("3", NoPainImage),
      loadImage("2", MildPainImage),
      loadImage("1", ModeratePainImage),
      loadImage("0", SeverePainImage),
    ]).then(() => setLoadedImages(images)); // Set loaded images after all promises resolve
  }, []);

  useEffect(() => {
    console.log("Duration selected ", selectedDuration);
    setCurrentMinutes(selectedDuration - 1);
  }, [selectedDuration]);

  useEffect(() => {
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    console.log("Left force array ", leftForceArray);
    console.log("Right force array ", rightForceArray);
  }, [leftForceArray, rightForceArray]);

  useEffect(() => {
    console.log("Left wave array ", leftWaveform);
    console.log("Right wave array ", rightWaveform);
  }, [leftWaveform, rightWaveform]);

  const handlePainAssessmentChange = (joint, value) => {
    setFormData((prev) => ({
      ...prev,
      [joint]: value, // Update specific joint's pain level
    }));
  };
  // const generateWaveformData = (numPoints) => {
  //   return Array.from(
  //     { length: numPoints },
  //     () => Math.floor(Math.random() * 20) + 100
  //   );
  // };
  // useEffect(() => {
  //   // Generate 600 random data points for testing

  //   setLeftForceArray(generateRandomData(60));
  //   setRightForceArray(generateRandomData(60));
  // }, []);

  const countDown = (data) => {
    // Get previous values as fallback
    const lastLeft = leftForceArray.at(-1) || 0;
    const lastRight = rightForceArray.at(-1) || 0;
    setStepCount((prev) => prev + 1);
    let leftForce = lastLeft;
    let rightForce = lastRight;

    //Waveform
    const lastLeftWave = leftWaveform.at(-1) || 0;
    const lastRightWave = rightWaveform.at(-1) || 0;
    setStepCount((prev) => prev + 1);
    let leftWave = lastLeftWave;
    let rightWave = lastRightWave;

    if (data["side"] === "Right") {
      rightForce = Math.floor(data["peakValue"] * 100);
      rightWave = Math.floor(data["avgWaveform"] * 100);

      setRightForceArray((prev) => [...prev, rightForce]);
      setRightWaveform((prev) => [...prev, rightWave]);
      setRightForce(rightForce);
      setAvgRightForce(calculateAverage([...rightForceArray, rightForce]));
    } else {
      leftForce = Math.floor(data["peakValue"] * 100);
      leftWave = Math.floor(data["avgWaveform"] * 100);

      setLeftForceArray((prev) => [...prev, leftForce]);
      setLeftWaveform((prev) => [...prev, leftWave]);
      setLeftForce(leftForce);
      setAvgLeftForce(calculateAverage([...leftForceArray, leftForce]));
    }

    // const updatedLeftForceArray = [...leftForceArray, leftForce];
    // const updatedRightForceArray = [...rightForceArray, rightForce];
    // const updatedLeftWaveform = [...leftWaveform, leftWave];
    // const updatedRightWaveform = [...rightWaveform, rightWave];

    // setLeftForce(leftForce);
    // setRightForce(rightForce);
    // setLeftForceArray(updatedLeftForceArray);
    // setRightForceArray(updatedRightForceArray);
    // setAvgLeftForce(calculateAverage(updatedLeftForceArray));
    // setAvgRightForce(calculateAverage(updatedRightForceArray));
    // setLeftWaveform(updatedLeftWaveform);
    // setRightWaveform(updatedRightWaveform);
  };

  const calculateAccuracy = () => {
    if (!selectedTarget) return null;

    const isWithinRange = (step) =>
      step >= selectedTarget - 5 && step <= selectedTarget + 5;

    const matchLeft = leftForceArray.filter(isWithinRange).length;
    const matchRight = rightForceArray.filter(isWithinRange).length;
    const totalMatches = matchLeft + matchRight;
    const totalSteps = leftForceArray.length + rightForceArray.length;

    return ((totalMatches / totalSteps) * 100).toFixed(2) + "%"; // e.g., "87.50%"
  };
  const saveSession = () => {
    console.log("Sve session");
    setPreSession(true);
    setEndSession(false);
    const computedAccuracy = calculateAccuracy();
    setSessionResult({
      leftForceArray: leftForceArray,
      rightForceArray: rightForceArray,
      avgLeftForce: avgLeftForce,
      avgRightForce: avgRightForce,
      stepCount: leftForceArray.length,
      stepTime: leftForceArray.length / (selectedDuration * 60),
      accuracy: computedAccuracy || "100%",
      stepCounts: stepCount,
      stepTimes: stepTime,
    });
    setSelectedTab("Results");
    sendHistory();
  };
  const calculateAverage = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return 0;
    return (
      arr.reduce((cumulativeSum, nextNumber) => cumulativeSum + nextNumber, 0) /
      arr.length
    );
  };
  const sendHistory = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      `Bearer ${localStorage.getItem("token")}`
    );
    const raw = JSON.stringify({
      patientId: patient._id,
      sessionDate: new Date().toISOString().slice(0, 10),
      sessionData: {
        leftHip: formData.leftHip,
        rightHip: formData.rightHip,
        leftAnkle: formData.leftAnkle,
        rightAnkle: formData.rightAnkle,
        leftKnee: formData.leftKnee,
        rightKnee: formData.rightKnee,
        avgLeftForce: avgLeftForce,
        avgRightForce: avgRightForce,
        peakLeftForce: Math.max(...leftForceArray),
        peakRightForce: Math.max(...rightForceArray),
      },
    });
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/patientHistory/addSession`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  const toggleLED = async () => {
    if (!isHubConnected || !ledCharacteristic || sessionStarted) return;

    try {
      await ledCharacteristic.writeValue(new TextEncoder().encode("start"));
      setSessionStarted(true);
      setGoNext(false);
      startTimer();
      console.log("Toggled LED");
    } catch (error) {
      console.error("Error toggling LED:", error);
    }
  };

  const startTimer = () => {
    clearInterval(intervalRef.current);
    let minutes = currentMinutes;
    let seconds = currentSeconds;

    intervalRef.current = setInterval(() => {
      if (seconds > 0) {
        seconds -= 1;
      } else {
        seconds = 59;
        minutes -= 1;
      }

      if (minutes === -1) {
        minutes = 0;
        seconds = 0;
        setGoNext(true);
        setSessionStarted(false);
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        return;
      }

      setCurrentMinutes(minutes);
      setCurrentSeconds(seconds);
      setElapsedSeconds((prev) => prev + 1);

    }, 1000);
  };

  const handleFeedback = (event) => {
    const decoder = new TextDecoder("utf-8");
    const rawData = decoder.decode(event.target.value.buffer).trim();
    console.log("Raw data received:", rawData); // Add this line
    // Parse values using regex
    //const pattern = /I:(\d+)\|T:(\d+\.\d+)\|S:(Left|Right)\|V:(\d+\.\d+)/;
    // I:12|T:1756720278.44|S:Left|V:1.0310|A:0.5207
    const pattern =
      /^I:(\d+)\|T:(\d+(?:\.\d+)?)\|S:(Left|Right)\|V:(\d+(?:\.\d+)?)\|A:(\d+(?:\.\d+)?)$/;

    const match = rawData.match(pattern);

    if (match) {
      const parsedData = {
        id: parseInt(match[1]),
        time: parseFloat(match[2]),
        side: match[3],
        peakValue: parseFloat(match[4]),
        avgWaveform: parseFloat(match[5]),
        timestamp: new Date().toISOString(),
      };
      const display = `ID: ${parsedData.id}, Time: ${parsedData.time}, Side: ${parsedData.side}, Peak: ${parsedData.peakValue}, Average Waveform: ${parsedData.avgWaveform}`;
      setEsp32Data(display);
      setParsedData(parsedData);
      setStepTime((prev) => {
        const lastTime = prev[prev.length - 1] || 0;
        const delta = parsedData.time - lastTime;
        return [...prev, delta];
      });
      countDown(parsedData);
      setDataLog((prev) => [...prev, parsedData]);
    } else {
      console.warn("Received unrecognized data format:", rawData);
    }
  };

  const prepareNewSession = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    setSessionStarted(false);
    setGoNext(false);
    setEndSession(false);
    setCurrentMinutes(Number(selectedDuration) - 1);
    setCurrentSeconds(59);
    setElapsedSeconds(0);
    setLeftForce(0);
    setRightForce(0);
    setLeftForceArray([]);
    setRightForceArray([]);
    setLeftWaveform([]);
    setRightWaveform([]);
    setAvgLeftForce(0);
    setAvgRightForce(0);
    setStepCount(0);
    setStepTime([0]);
    setEsp32Data("");
    setParsedData("");
    setDataLog([]);
    setOpenSession(true);
  };

  feedbackHandlerRef.current = handleFeedback;

  useEffect(() => {
    if (!device) return undefined;

    const handleGattDisconnected = () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setIsHubConnected(false);
      setSessionStarted(false);
      setLedCharacteristic(null);
      setFeedbackCharacteristic(null);
      feedbackListenerRef.current = null;
      setDevice(null);
    };

    device.addEventListener("gattserverdisconnected", handleGattDisconnected);
    return () => {
      device.removeEventListener(
        "gattserverdisconnected",
        handleGattDisconnected
      );
    };
  }, [device]);

  const connectToHub = async () => {
    if (isConnecting || isHubConnected) return;

    let deviceConnected;
    setIsConnecting(true);
    try {
      deviceConnected = await navigator.bluetooth.requestDevice({
        filters: [{ services: ["12345678-1234-1234-1234-123456789012"] }],
        optionalServices: ["12345678-1234-1234-1234-123456789012"],
      });
      const server = await deviceConnected.gatt.connect();
      const service = await server.getPrimaryService(
        "12345678-1234-1234-1234-123456789012"
      );
      let ledChar = await service.getCharacteristic(
        "12345678-1234-1234-1234-123456789013"
      );
      setLedCharacteristic(ledChar);
      let feedbackChar = await service.getCharacteristic(
        "12345678-1234-1234-1234-123456789014"
      );
      setFeedbackCharacteristic(feedbackChar);
      setDeviceName(deviceConnected.name || "Unknown Device");
      const feedbackListener = (event) => feedbackHandlerRef.current(event);
      feedbackListenerRef.current = feedbackListener;
      feedbackChar.addEventListener(
        "characteristicvaluechanged",
        feedbackListener
      );
      await feedbackChar.startNotifications();

      setDevice(deviceConnected);
      setIsHubConnected(true);
      setDataLog([]);
      console.log("Connected to ESP32");
    } catch (error) {
      if (deviceConnected?.gatt?.connected) {
        deviceConnected.gatt.disconnect();
      }
      setDevice(null);
      setIsHubConnected(false);
      setLedCharacteristic(null);
      setFeedbackCharacteristic(null);
      console.error("Error:", error);
    } finally {
      setIsConnecting(false);
    }
  };

  const disconnectBLE = async () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    setSessionStarted(false);

    if (feedbackCharacteristic) {
      const listener = feedbackListenerRef.current;
      if (listener) {
        feedbackCharacteristic.removeEventListener(
          "characteristicvaluechanged",
          listener
        );
      }

      try {
        await feedbackCharacteristic.stopNotifications();
      } catch (error) {
        console.warn("Unable to stop hub notifications:", error);
      }
    }

    if (device?.gatt?.connected) {
      device.gatt.disconnect();
      console.log("Disconnected from ESP32");
    }

    saveLogToFile();
    setIsHubConnected(false);
    setDevice(null);
    setDeviceName("");
    setLedCharacteristic(null);
    setFeedbackCharacteristic(null);
    feedbackListenerRef.current = null;
  };

  const handleStopSession = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    setSessionStarted(false);
    setGoNext(true);
  };

  const handleSessionEnd = async () => {
    await disconnectBLE();
    setEndSession(true);
    setOpenSession(false);
  };
  const saveLogToFile = () => {
    if (dataLog.length === 0) return;

    let jsonContent = JSON.stringify(dataLog, null, 2);
    let blob = new Blob([jsonContent], { type: "application/json" });
    let a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `data_log_session_${sessionCount}.json`;
    a.click();
    sessionCount++;
  };

  const sessionControls = getSessionControlState({
    isHubConnected,
    isConnecting,
    sessionStarted,
    goNext,
  });

  return patient ? (
    <div className="pageContainer">
      <div className=" h1 pageHeader">
        {role === "Clinician" && (
          <div>
            <a href="/patients">Patients</a> &gt;{" "}
            {patient.firstName + " " + patient.lastName}
          </div>
        )}
      </div>
      <div className="row" style={{ borderBottom: "1px solid #E0E0E0" }}>
        <div className="patientTab">
          <input
            type="radio"
            name="patientTabs"
            id="profile"
            value="Profile"
            checked={selectedTab === "Profile"}
            onChange={(e) => setSelectedTab(e.target.value)}
            style={{
              padding: "0.62rem 1.5rem",
              marginRight: "0.5rem",
              color: "var(--midGray",
            }}
          />
          <label htmlFor="profile" className="b1">
            Profile
          </label>
        </div>
        <div className="patientTab">
          <input
            type="radio"
            name="patientTabs"
            id="sessions"
            value="Sessions"
            checked={selectedTab === "Sessions"}
            onChange={(e) => {
              setSelectedTab(e.target.value);
            }}
            style={{
              padding: "0.62rem 1.5rem",
              marginRight: "0.5rem",
              color: "var(--midGray",
            }}
          />
          <label htmlFor="sessions" className="b1">
            Sessions
          </label>
        </div>
        <div className="patientTab">
          <input
            type="radio"
            name="patientTabs"
            id="results"
            value="Results"
            onChange={(e) => setSelectedTab(e.target.value)}
            checked={selectedTab === "Results"}
            style={{
              padding: "0.62rem 1.5rem",
              marginRight: "0.5rem",
              color: "var(--midGray",
            }}
          />
          <label htmlFor="results" className="b1">
            Results
          </label>
        </div>
        <div className="patientTab">
          <input
            type="radio"
            name="patientTabs"
            id="history"
            value="History"
            checked={selectedTab === "History"}
            onChange={(e) => setSelectedTab(e.target.value)}
            style={{
              padding: "0.62rem 1.5rem",
              marginRight: "0.5rem",
              color: "var(--midGray",
            }}
          />
          <label htmlFor="history" className="b1">
            History
          </label>
        </div>
      </div>
      {selectedTab === "Profile" && (
        <PatientProfile
          patient={patient}
          patientImage={patientImage}
          setPatientImage={setPatientImage}
          clinicianNotes={clinicianNotes}
          setClinicianNotes={setClinicianNotes}
          selectedTreatmentStatus={selectedTreatmentStatus}
          setSelectedTreatmentStatus={setSelectedTreatmentStatus}
          saveChanges={saveChanges}
          setSaveChanges={setSaveChanges}
        />
      )}
      {selectedTab === "Sessions" &&
        (openSession ? (
          <div style={{ marginLeft: "1.5rem" }}>
            <div>
              <div>
                <button
                  className="button1 h3"
                  disabled={!sessionControls.canConnect}
                  onClick={connectToHub}
                >
                  {isConnecting ? "CONNECTING..." : "CONNECT TO HUB"}
                </button>
                <button
                  disabled={!sessionControls.canStart}
                  className="button2 h3"
                  onClick={toggleLED}
                >
                  START SESSION
                </button>
                <button
                  className="button2 h3"
                  disabled={!sessionControls.canDisconnect}
                  onClick={disconnectBLE}
                >
                  DISCONNECT
                </button>
              </div>
              {sessionStarted && (
                <div className="b2 midGray" style={{ margin: "3rem 0" }}>
                  You are connected to {deviceName}.<br />
                  You have successfully initiated the real-time feedback
                  session.
                </div>
              )}
              <div>{esp32Data}</div>
              <div style={{ width: "358px" }}>
                {
                  <BarChart
                    leftForce={leftForce}
                    rightForce={rightForce}
                    displayTargetForce={sessionType === "Treat"}
                    targetForce={selectedTarget}
                  />
                }
              </div>
              <div className="timerContainer">
                <div className="b2 midGray">
                  {currentMinutes}:
                  {currentSeconds < 10 ? `0${currentSeconds}` : currentSeconds}/{" "}
                  {selectedDuration}:00
                </div>
                <div className="timerBox">
                  <div
                    style={{
                      width: `${
                        100 - (elapsedSeconds / (selectedDuration * 60)) * 100
                      }%`,
                      height: "100%",
                      background: "#6893B4",
                      transition: "width 0.3s linear",
                    }}
                  ></div>
                </div>
              </div>
            </div>
            <div>
              <button
                className="button1 h3"
                style={{ marginRight: "3.19rem" }}
                onClick={handleSessionEnd}
                disabled={!sessionControls.canGoNext}
              >
                NEXT
              </button>
              <button
                className="button2 h3"
                disabled={!sessionControls.canStop}
                onClick={handleStopSession}
              >
                STOP
              </button>
            </div>
          </div>
        ) : endSession ? (
          <div style={{ marginLeft: "2rem" }}>
            <PainAssessment
              prefix="endSession"
              onChange={handlePainAssessmentChange}
              selectedValue={formData}
            />
            <button
              className="button1 white h3"
              style={{ background: "var(--hippieBlue" }}
              onClick={() => {
                saveSession();
              }}
            >
              SAVE
            </button>
          </div>
        ) : preSession ? (
          <div style={{ marginLeft: "2rem" }}>
            <div className="b2 midGray" style={{ marginTop: "2rem" }}>
              Please select the appropriate session module to begin. You will
              receive real-time feedback from the devices.
            </div>
            <div className="row centerAlign">
              <div className="sessionClass">
                <input
                  onChange={(e) => setSessionType(e.target.value)}
                  type="radio"
                  name="sessionClass"
                  id="detect"
                  value="Detect"
                  defaultChecked={true}
                />
                <label className="h4" htmlFor="detect">
                  DETECT
                </label>
              </div>
              <div className="sessionClass">
                <input
                  onChange={(e) => setSessionType(e.target.value)}
                  type="radio"
                  name="sessionClass"
                  id="treat"
                  value="Treat"
                />
                <label className="h4" htmlFor="treat">
                  TREAT
                </label>
              </div>
              <div className="sessionClass">
                <input
                  onChange={(e) => setSessionType(e.target.value)}
                  type="radio"
                  name="sessionClass"
                  id="monitor"
                  value="Monitor"
                />
                <label className="h4" htmlFor="monitor">
                  MONITOR
                </label>
              </div>
            </div>
            <div
              className="b2 row centerAlign"
              style={{ margin: "1.5rem 0", gap: "0.5rem" }}
            >
              Session duration
              <select
                style={{ width: "3rem" }}
                name="duration"
                id="duration"
                value={selectedDuration}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                {Array.from({ length: 10 }, (_, i) => {
                  const print = (i + 1).toString().padStart(2, "0");
                  return (
                    <option key={i + 1} value={i + 1}>
                      {print}
                    </option>
                  );
                })}
              </select>{" "}
              Minutes
            </div>
            {sessionType === "Treat" && (
              <div
                className="b2 row centerAlign"
                style={{ margin: "1.5rem 0", gap: "0.5rem" }}
              >
                <div>Target</div>
                <select
                  style={{ width: "max-content" }}
                  name="targetForce"
                  id="targetForce"
                  value={selectedTarget}
                  onChange={(e) => {
                    console.log("Target ", e.target.value);
                    setSelectedTarget(e.target.value);
                  }}
                >
                  <option value={112}>Clinical Overground - 112</option>
                  <option value={115}>Clinical Treadmill - 115</option>
                  {/* {Array.from({ length: 10 }, (_, i) => {
                    const print = (90 + i * 5).toString();
                    return <option value={90 + i * 5}>{print}</option>;
                  })} */}
                </select>{" "}
                %Force
              </div>
            )}
            <PainAssessment
              prefix={sessionType}
              onChange={handlePainAssessmentChange}
              selectedValue={formData}
            />

            <div className="row">
              {/* <button
                className="button2 h3"
                style={{ background: "var(--white", marginRight: "3.19rem" }}
                onClick={() => {
                  prepareNewSession();
                }}
              >
                SKIP THE PAIN SURVEY
              </button> */}
              <button
                className="button1 white h3"
                style={{ background: "var(--hippieBlue" }}
                onClick={prepareNewSession}
              >
                START THE SESSION
              </button>
            </div>
          </div>
        ) : (
          <></>
        ))}
      {selectedTab === "Results" && (
        <SessionResult
          sessionType={sessionType}
          sessionData={sessionResult}
          selectedDuration={selectedDuration}
          leftForceArray={leftForceArray}
          rightForceArray={rightForceArray}
          leftWaveform={leftWaveform}
          rightWaveform={rightWaveform}
          calculateAverage={calculateAverage}
          selectedTarget={selectedTarget}
          stepCounts={stepCount}
          stepTimes={stepTime}
        />
      )}
      {selectedTab === "History" && (
        <PatientHistory
          patientHistory={patientHistory}
          setSelectedTab={setSelectedTab}
        />
      )}
    </div>
  ) : (
    <div>LOADING</div>
  );
};

export default PatientDetails;
